import React, { createContext, useState } from 'react';
import { Card, Form } from "react-bootstrap";
import ComponentIdentifier from "../CommonComponent/ComponentHeader/ComponentIdentifier";
import WalletHistoryForm from "../AgentWalletHistoryComponent/SubComponent/WalletHistoryForm";
import WalletHistoryTable from "../AgentWalletHistoryComponent/SubComponent/WalletHistoryTable";
import CollectionHistoryForm from "./SubComponent/CollectionHistoryForm";
import CollectionHistoryTable from "./SubComponent/CollectionHistoryTable";
// Context
export const AgentCollectionHistoryContext = createContext()

function AgentCollectionHistoryComponent(props) {
    //state
    const [agentCollectionHistory, setAgentCollectionHistory] = useState([])
    const [dateFilter, setDateFilter] = useState(false)
    return (
        <>
            <AgentCollectionHistoryContext.Provider value={{
                agentCollectionHistory,
                setAgentCollectionHistory
            }}>
                <Card>
                    <Card.Header className="d-flex align-items-center justify-content-between">

                        <div className='d-flex align-items-center justify-content-between  w-100'>
                            <ComponentIdentifier link_name={"Agent Collection History"} component_name={""} />
                            <Form.Check // prettier-ignore
                                type={"checkbox"}
                                value={dateFilter}
                                label={`Date filter`}
                                onChange={(e) => {
                                    setDateFilter(e.target.checked)
                                }}
                            />
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {dateFilter && <CollectionHistoryForm is_date_filter={true} />}
                        {!dateFilter && <CollectionHistoryForm />}
                        <CollectionHistoryTable />
                    </Card.Body>
                </Card>
            </AgentCollectionHistoryContext.Provider>

        </>
    );
}

export default AgentCollectionHistoryComponent;